import { Alert, Snackbar } from '@mui/material';
import React, { createContext, useState, useContext, useEffect } from 'react';


const QuantityContext = createContext();

export const QuantityProvider = ({ children }) => {


  const [quantity, setQuantity] = useState(2);
  const [isNavigationBlocked, setisNavigationBlocked] = useState(false);
  const [sortOrder, setSortOrder] = useState(null);
  const [sortDateOrder, setSortDateOrder] = useState(null);
  const [latestDateOrder, setlatestDateOrder] = useState(null);
  // for Contacts
  const [activeGrpName, setActiveGrpName] = useState(false);
  const [isEnabledCCE, setIsEnabledCCE] = useState(true);
  const [ContactView, setContactsView] = useState("Grid View");
  const [FilterOpen, setFilterOpen] = useState(false);
  //for Group Card
  const [GroupCardView, setGroupCardView] = useState("grouptree");

  const [groupId, setGroupId] = useState(null);
  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [snackbarAutoclose, setSnackbarAutoclose] = useState(6000);


  const handleCardClick = (activeTab) => {
    setGroupCardView(activeTab);
  };

  const handleClickFilter = () => {
    setFilterOpen(!FilterOpen);
  };

  const openSnackbar = (message, severity = 'success', autoClose = 6000) => {
    setSnackbarOpen(true);
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarAutoclose(autoClose);
  };

  const handleSuccess = (message, severity = "success", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  }

  const handleFailure = (message, severity = "error", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  }

  const handleInfo = (message, severity = "info", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  return (
    <QuantityContext.Provider value={{
      quantity, setQuantity, isEnabledCCE, setIsEnabledCCE, isNavigationBlocked, setisNavigationBlocked,
      sortOrder, setSortOrder, sortDateOrder, setSortDateOrder, latestDateOrder, setlatestDateOrder,
      ContactView, setContactsView, FilterOpen, handleClickFilter, activeGrpName, setActiveGrpName,
      GroupCardView, handleCardClick, openSnackbar, handleSuccess, handleFailure, handleInfo, groupId, setGroupId,
      // toggleBtn, setToggleBtn
    }}>
      {children}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={snackbarAutoclose}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </QuantityContext.Provider>
  );
};

export const useQuantityContext = () => useContext(QuantityContext);
